<template>
  <el-select
    :value="selectedEvent"
    :placeholder="$t('settings.dropDownPlaceholder')"
    :loading="loading"
    @change="updateMeals"
  >
    <el-option v-for="event in events" :key="event.name" :label="event.name" :value="event.id">
    </el-option>
  </el-select>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import Case from 'case';

export default {
  name: 'EventSelection',
  props: {
    selectedEvent: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  async created() {
    await this.getEvents();
    this.loading = false;
  },
  computed: {
    ...mapState('events', { mealEvents: (state) => state.mealEvents }),
    events() {
      return this.mealEvents.map((e) => ({ name: Case.capital(e.name), id: e.id }));
    },
  },
  methods: {
    ...mapActions('events', { getEvents: 'initializeEvents' }),
    updateMeals(selectedMeal) {
      this.$emit('change', selectedMeal);
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../scss/variables';

.el-select-dropdown {
  &__item {
    font-family: 'Avenir';
  }
}
</style>



// WEBPACK FOOTER //
// src/components/catering/EventSelection.vue